import { render, staticRenderFns } from "./CalendarListItemSharingSearch.vue?vue&type=template&id=4ff5cf4c&"
import script from "./CalendarListItemSharingSearch.vue?vue&type=script&lang=js&"
export * from "./CalendarListItemSharingSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/christoph/workspace/nextcloud/apps/calendar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ff5cf4c')) {
      api.createRecord('4ff5cf4c', component.options)
    } else {
      api.reload('4ff5cf4c', component.options)
    }
    module.hot.accept("./CalendarListItemSharingSearch.vue?vue&type=template&id=4ff5cf4c&", function () {
      api.rerender('4ff5cf4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AppNavigation/CalendarList/CalendarListItemSharingSearch.vue"
export default component.exports